import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
// Theme styles
import './assets/scss/themes.scss';
import App from './App';
// import AppTest from './AppTest'; // Uncomment to test basic rendering
import reportWebVitals from './reportWebVitals';
import store from './app/store';
import { syncEnvelopeQuotaFromApi } from './features/subscription/subscriptionSlice';
import { registerEnvelopeQuotaSyncHandler } from './utils/envelopeQuotaSync';

registerEnvelopeQuotaSyncHandler((envelopeQuota) => {
  store.dispatch(syncEnvelopeQuotaFromApi(envelopeQuota));
});

const root = ReactDOM.createRoot(document.getElementById('root'));

console.log('React is initializing...');
console.log('Root element:', document.getElementById('root'));

// Note: StrictMode is disabled to prevent duplicate API requests in development
// StrictMode intentionally double-invokes effects, which causes duplicate API calls
// In production builds, this doesn't happen, but we disable it here to prevent issues
root.render(
  <App />
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
